import Vue from 'vue';
import Vuex from 'vuex';

import urlsAPI from '../../config/urlsAPI';
import handlerError from '../../utils/errors';
import { axiosInstance, busEvent } from '../../main';

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    all: [],
    document: {
      id: 0,
      type: '',
      name: '',
    },
  },
  mutations: {
    updateDocument(state, element) {
      state.document = element;
    },
    updateDocuments(state, elements) {
      state.all = elements;
    },
    add(state, note) {
      state.all.push(note);
    },
    putDocument(state, document) {
      state.documents = state.documents.map((value) =>
        document.id === value.id ? document : value
      );
    },
    deleteAction(state, id) {
      state.all = state.all.filter((element) => element.id !== id);
    },
  },
  actions: {
    async getDocument({ commit }, { clientId, documentId }) {
      try {
        const response = await axiosInstance.get(
          urlsAPI.clientsURL + clientId + urlsAPI.documentsURL + documentId
        );

        if (response.data.error) {
          handlerError(response.data.error);
        }

        commit('updateDocument', response.data);
        return response.data;
      } catch (e) {
        return handlerError(e);
      }
    },

    async getLastDocument(_, { documentType }) {
      try {
        const response = await axiosInstance.get(`${urlsAPI.documentsLastURL}`, {
          params: {
            type: documentType,
          },
        });
        if (response.data.error) {
          return handlerError(response.data.error);
        } else if (!response.data.number || (response.data.number && isNaN(response.data.number))) {
          busEvent.$emit(
            'errorPopupCreated',
            'Numarul curent al documentului nu a putut fi procesat. Va rugam sa reincarcati pagina.'
          );

          return;
          // throw { response: {data: { error: {code: 0,message: 'Numarul curent al documentului nu a putut fi procesat. Va rugam sa reincarcati pagina.'}}}}
        }

        return response.data;
      } catch (e) {
        return handlerError(e);
      }
    },

    async download(_, { clientId, documentId }) {
      try {
        const response = await axiosInstance.get(
          `${
            urlsAPI.clientsURL +
            clientId +
            urlsAPI.documentsURL +
            documentId +
            urlsAPI.documentDownloadURL
          }`,
          {
            responseType: 'blob',
          }
        );
        if (response.data.error) {
          return handlerError(response.data.error);
        }

        return response;
      } catch (e) {
        return handlerError(e);
      }
    },

    async downloadCustom(_, { documentId }) {
      try {
        const response = await axiosInstance.get(
          `${urlsAPI.documentsBaseURL + documentId + urlsAPI.documentDownloadURL}`,
          {
            responseType: 'blob',
          }
        );
        if (response.data.error) {
          return handlerError(response.data.error);
        }

        return response;
      } catch (e) {
        return handlerError(e);
      }
    },

    async preview(_, { clientId, body }) {
      return axiosInstance
        .post(
          urlsAPI.clientsURL + clientId + urlsAPI.documentsURL + urlsAPI.documentPreviewURL,
          body,
          {
            responseType: 'blob',
          }
        )
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          }
          return response;
        })
        .catch(handlerError);
    },

    async previewCustom(_, { body }) {
      return axiosInstance
        .post(urlsAPI.documentsBaseURL + urlsAPI.documentPreviewURL, body)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          }
          return response;
        })
        .catch(handlerError);
    },

    async sendEmail(_, { clientId, documentId }) {
      return axiosInstance
        .post(
          `${
            urlsAPI.clientsURL +
            clientId +
            urlsAPI.documentsURL +
            documentId +
            urlsAPI.documentSendURL
          }`
        )
        .then(() => {
          busEvent.$emit('succesPopupCreated', 'Emailul a fost trimis cu succes');
        })
        .catch(handlerError);
    },

    async sendEmailCustom(_, { documentId, type }) {
      return axiosInstance
        .post(`${urlsAPI.documentsBaseURL + documentId + urlsAPI.documentSendURL}?type=${type}`)
        .then(() => {
          busEvent.$emit('succesPopupCreated', 'Emailul a fost trimis cu succes');
        })
        .catch(handlerError);
    },

    getDocuments({ commit }, clientId) {
      axiosInstance
        .get(urlsAPI.clientsURL + clientId + urlsAPI.documentsURL)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateDocuments', response.data);
          }
        })
        .catch(handlerError);
    },

    getCustomDocuments({ commit }) {
      axiosInstance
        .get(urlsAPI.documentsBaseURL)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateDocuments', response.data);
          }
        })
        .catch(handlerError);
    },

    create({ commit }, { clientId, body }) {
      axiosInstance
        .post(urlsAPI.clientsURL + clientId + urlsAPI.documentsURL, body)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('add', response.data);
          }
        })
        .catch(handlerError);
    },

    update({ commit }, { clientId, body }) {
      axiosInstance
        .put(urlsAPI.clientsURL + clientId + urlsAPI.documentsURL, body)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('putDocument', response.data);
          }
        })
        .catch(handlerError);
    },

    createCustom({ commit }, { body }) {
      axiosInstance
        .post(urlsAPI.documentsBaseURL, body)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('add', response.data);
          }
        })
        .catch(handlerError);
    },

    updateCustom({ commit }, { body }) {
      axiosInstance
        .put(urlsAPI.documentsBaseURL, body)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('add', response.data);
          }
        })
        .catch(handlerError);
    },

    delete({ commit }, { clientId, documentId }) {
      axiosInstance
        .delete(urlsAPI.clientsURL + clientId + urlsAPI.documentsURL + documentId)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('deleteAction', documentId);
          }
        })
        .catch(handlerError);
    },

    deleteCustom({ commit }, { documentId }) {
      axiosInstance
        .delete(urlsAPI.documentsBaseURL + documentId)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('deleteAction', documentId);
          }
        })
        .catch(handlerError);
    },

    async downloadAccountancyDocuments(_, { start, end }) {
      try {
        busEvent.$emit(
          'succesPopupCreated',
          'Documentul se proceseaza... Poate dura cateva secunde'
        );
        const response = await axiosInstance.get(urlsAPI.documentsExportAccountancyDocumentsURL, {
          params: {
            start,
            end,
          },
          responseType: 'blob',
          timeout: 300000, // 5m
        });
        if (response.data.error) {
          return handlerError(response.data.error);
        }

        return response;
      } catch (e) {
        return handlerError(e);
      }
    },

    async printInvoices(_, { start, end }) {
      try {
        busEvent.$emit(
          'succesPopupCreated',
          'Documentul se proceseaza... Poate dura cateva secunde'
        );
        const response = await axiosInstance.get(urlsAPI.documentsPrintInvoiceURL, {
          params: {
            start,
            end,
          },
          responseType: 'blob',
          timeout: 300000, // 5m
        });
        if (response.data.error) {
          return handlerError(response.data.error);
        }

        return response;
      } catch (e) {
        return handlerError(e);
      }
    },

    async getExcelInvoices(_, { start, end }) {
      return axiosInstance
        .get(urlsAPI.invoicesExportExcelURL, {
          params: {
            start,
            end,
          },
          responseType: 'blob',
        })
        .then((response) => {
          if (response.data.error) {
            return handlerError(response.data.error);
          }
          return response;
        })
        .catch(handlerError);
    },

    async getExcelOpisInvoices(_, { start, end }) {
      return axiosInstance
        .get(urlsAPI.invoicesExportOpisURL, {
          params: {
            start,
            end,
          },
          responseType: 'blob',
        })
        .then((response) => {
          if (response.data.error) {
            return handlerError(response.data.error);
          }
          return response;
        })
        .catch(handlerError);
    },

    async getIscirDocuments(_, { start, end }) {
      return axiosInstance
        .get(urlsAPI.documentsExportIscirURL, {
          params: {
            start,
            end,
          },
          responseType: 'blob',
        })
        .then((response) => {
          if (response.data.error) {
            return handlerError(response.data.error);
          }
          return response;
        })
        .catch(handlerError);
    },

    async getAnreDocuments(_, { start, end }) {
      return axiosInstance
        .get(urlsAPI.documentsExportAnreExcelURL, {
          params: {
            start,
            end,
          },
          responseType: 'blob',
        })
        .then((response) => {
          if (response.data.error) {
            return handlerError(response.data.error);
          }
          return response;
        })
        .catch(handlerError);
    },

    async getInvoice(_, cnp) {
      try {
        const response = await axiosInstance.get(`${urlsAPI.invoicesURL}`, {
          params: {
            cnp,
          },
        });
        if (response.data.error) {
          return handlerError(response.data.error);
        }

        return response.data;
      } catch (e) {
        return handlerError(e);
      }
    },

    async getInvoiceById(_, id) {
      try {
        const response = await axiosInstance.get(`${urlsAPI.invoicesURL}/${id}`);
        if (response.data.error) {
          return handlerError(response.data.error);
        }

        return response.data;
      } catch (e) {
        return handlerError(e);
      }
    },

    searchDocument({ commit }, keyword) {
      axiosInstance
        .get(urlsAPI.documentSearchURL, {
          params: {
            keyword,
          },
        })
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateDocuments', response.data);
          }
        })
        .catch(handlerError);
    },

    async downloadAnreDocuments(body, { start, end }) {
      busEvent.$emit('succesPopupCreated', 'Documentul se proceseaza... Poate dura cateva secunde');

      try {
        const response = await axiosInstance.get(urlsAPI.documentsExportAnreFilesURL, {
          params: {
            start,
            end,
          },
          responseType: 'blob',
          timeout: 1800000, // 30min = 1000*60*30
        });
        if (response.data.error) {
          return handlerError(response.data.error);
        }

        return response;
      } catch (e) {
        return handlerError(e);
      }
    },

    async getConsumptionReceipts(_, { start, end }) {
      return axiosInstance
        .get(urlsAPI.documentsExporConsumptionReceiptsURL, {
          params: {
            start,
            end,
          },
          responseType: 'blob',
        })
        .then((response) => {
          if (response.data.error) {
            return handlerError(response.data.error);
          }
          return response;
        })
        .catch(handlerError);
    },

    async syncEInvoice(_, id) {
      try {
        const response = await axiosInstance.post(`${urlsAPI.invoicesURL}/${id}/sync-einvoice`, {});
        if (response.data.error) {
          return handlerError(response.data.error);
        }

        busEvent.$emit('succesPopupCreated', 'EFactura a fost trimisa cu succes');
        // return response.data;
      } catch (e) {
        return handlerError(e);
      }
    },
  },
};
